const IconMap = {
    amazon: {
        color: '#ffac36',
        icon: 'amazon',
        text: 'Amazon',
        link: 'https://www.amazon.com/'
    },
    behance: {
        icon: 'behance',
        text: 'Behance',
        link: 'https://www.behance.net/'
    },
    deviantart: {
        icon: 'deviantart',
        text: 'Deviant Art',
        link: 'https://www.deviantart.com/'
    },
    dribbble: {
        icon: 'dribbble',
        text: 'Dribbble',
        link: 'https://dribbble.com/'
    },
    etsy: {
        icon: 'etsy',
        text: 'Etsy',
        link: 'https://www.etsy.com/'
    },
    facebook: {
        color: '#475893',
        icon: 'facebook',
        text: 'Facebook',
        link: 'https://www.facebook.com/'
    },
    flickr: {
        icon: 'flickr',
        text: 'Flickr',
        link: 'https://www.flickr.com/'
    },
    instagram: {
        icon: 'instagram',
        text: 'Instagram',
        link: 'https://www.instagram.com/'
    },
    kickstarter: {
        icon: 'kickstarter',
        text: 'Kickstarter',
        link: 'https://www.kickstarter.com/'
    },
    linkedin: {
        icon: 'linkedin',
        text: 'LinkedIn',
        link: 'https://www.linkedin.com/'
    },
    medium: {
        icon: 'medium',
        text: 'Medium',
        link: 'https://medium.com/'
    },
    pinterest: {
        icon: 'pinterest',
        text: 'Pinterest',
        link: 'https://www.pinterest.com/'
    },
    quora: {
        icon: 'quora',
        text: 'Quora',
        link: 'https://www.quora.com/profile/'
    },
    reddit: {
        icon: 'reddit',
        text: 'Reddit',
        link: 'https://www.reddit.com/'
    },
    scribd: {
        icon: 'scribd',
        text: 'Scribd',
        link: 'https://www.scribd.com/'
    },
    shutterstock: {
        icon: 'shutterstock',
        text: 'Shutterstock',
        link: 'https://www.shutterstock.com/'
    },
    slack: {
        icon: 'slack',
        text: 'Slack',
        link: 'https://'
    },
    snapchat: {
        icon: 'snapchat',
        text: 'Snapchat',
        link: 'https://www.snapchat.com/add/'
    },
    soundcloud: {
        icon: 'soundcloud',
        text: 'Soundcloud',
        link: 'https://soundcloud.com/'
    },
    spotify: {
        icon: 'spotify',
        text: 'Spotify',
        link: 'https://www.spotify.com/'
    },
    tumblr: {
        icon: 'tumblr',
        text: 'Tumblr',
        link: 'https://'
    },
    twitter: {
        icon: 'twitter',
        text: 'Twitter',
        link: 'https://twitter.com/'
    },
    vimeo: {
        icon: 'vimeo',
        text: 'Vimeo',
        link: 'https://vimeo.com/'
    },
    wikipedia: {
        icon: 'wikipedia',
        text: 'Wikipedia',
        link: 'https://en.wikipedia.org/wiki/'
    },
    wordpress: {
        icon: 'wordpress',
        text: 'Wordpress',
        link: 'https://'
    },
    yelp: {
        icon: 'yelp',
        text: 'Yelp',
        link: 'https://www.yelp.com/'
    },
    youtube: {
        icon: 'youtube',
        text: 'Youtube',
        link: 'https://www.youtube.com/channel/'
    }
}

const IconList = Object.keys(IconMap).map(i => {
    return IconMap[i]
})

module.exports = {
    IconMap,
    IconList
}
